<div #mapContainer class="mapview" id="map">

</div>
